import { render, staticRenderFns } from "./ExportSales.vue?vue&type=template&id=2da73485"
import script from "./ExportSales.vue?vue&type=script&lang=js"
export * from "./ExportSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports